<template>
  <v-card elevation="0" outlined class="h-100 d-flex flex-column" min-height="350">
    <v-card-title class="py-1 white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;"
      :class="$vuetify.theme.dark ? 'black' : 'primary'">
      <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
        <v-icon color="white" class="mr-2" medium>people</v-icon>
        <span
          class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{ $t("dashboards.myCollections") }}</span>
      </div>
      <v-btn class="pl-0 pr-0" text small :to="`/collections`" style="flex-shrink: 0;">
        <span class="white--text text-decoration-underline font-weight-bold">{{ $t('general.seeAll') }}</span>
        <v-icon small class="ml-1" color="white">keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="d-flex flex-column flex-grow-1 pa-0" style="min-height: 0;">
      <template v-if="!loading">
        <div class="d-flex flex-column pl-3 pr-3 pb-1 pt-2 flex-grow-1" v-if="collections && collections.length"
          style="overflow:auto">
          <CollectionCard v-for="(collection, index) in collections" :collection="collection" :key="index" embedded>
          </CollectionCard>
        </div>
        <div class="d-flex flex-column px-3 py-4 mb-7 text-center flex-grow-1 justify-center align-center"
          v-if="!collections || !collections.length">
          <v-icon color="primary lighten-5"
            v-bind:style="{ 'font-size': $vuetify.breakpoint.mdAndUp ? '80px' : '60px' }">create_new_folder</v-icon>
          <span class="primary--text lighten--text-2 body-1">{{ $t("dashboards.placeholderCollections") }}</span>
        </div>
      </template>

      <template v-else>
        <div class="mt-4 pl-6 pr-4 d-flex align-center justify-space-between">
          <v-skeleton-loader type="text" width="30%" class="ma-0"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="15%" class="ma-0"></v-skeleton-loader>
        </div>
        <div class="px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around">
          <v-skeleton-loader v-for="i in 4" :key="i" type="text" width="100%" class="my-2"></v-skeleton-loader>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import CollectionService from "../../../services/collection.service";
import * as moment from 'moment';
import CollectionCard from '../../collections/CollectionCard';

export default {
  name: "CollectionsWidget",
  components: {
    CollectionCard
  },
  props: {
  },
  data() {
    return {
      collections: null,
      loading: false
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {
      this.loadCollections();
    },
    async loadCollections() {
      this.loading = true;
      let collectionsResponse = await CollectionService.getAvailableCollections();
      let allCollections = _.chain(collectionsResponse.data).forEach(c => c.updated = moment(c.updatedAt, 'DD/MM/YYYY').format("YYYYMMDD")).orderBy(['updated', 'name'], ['desc', 'asc']).value();
      this.collections = _.chain(allCollections).filter((c) => !c.isPublic).orderBy(['id'], ['desc']).slice(0, 4).value();
      this.loading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/widgets/CollectionsWidget.vue